/*
  HeyCuida · lm-cart.js · carrito (cajón y página /cart con el mismo diseño) · 11/10/2026 · brief A.5.
  12/10: más corto (regalos en cuadrícula 2×2 con un solo aviso), reseña con foto de perfil, 953 opiniones de respaldo.
  JS vanilla, sin librerías ni apps. Original (v8) en tienda-heycuida/respaldo/carrito-antes-1341/assets/.

  Cómo funciona
  - El Liquid (snippets/hc-cart-body.liquid) deja en cada carrito (cajón y /cart) un <div data-hc-cart="drawer|page">
    con el objeto del carrito de la Ajax Cart API ({{ cart | json }}, igual que /cart.js) y el compare_at de cada
    variante (la Ajax API no lo trae). Este archivo calcula todo con funciones puras (computeCart, texts) y pinta
    la vista (renderView). Los mismos textos que se pintan son los que comprueban las pruebas en Node.
  - El tema repinta el carrito con la Section Rendering API (cart.js, cart-drawer.js y el selector de packs):
    cada repintado trae un <div data-hc-cart> nuevo, sin pintar; un MutationObserver lo ve y lo pinta. Nada depende
    de <script> en línea dentro del HTML repintado.
  - Cantidad, papelera y «Añadir» usan el JS del tema (quantity-input, cart-remove-button y updateQuantity de
    cart-items / cart-drawer-items): ids CartDrawer-Item-N / Drawer-quantity-N (cajón) y CartItem-N / Quantity-N (/cart).
  - Barra de reserva [data-hc-cart-timer] (snippets/lm-cart-timer.liquid): cuenta atrás real desde 10:00, guardada en
    localStorage (con try/catch; sin almacén, en memoria), sigue entre páginas y vuelve a 10:00 al caducar. Oculta con el
    carrito vacío.
  - Reseñas: window.HCReviews ({rating, total, sample:{author, body, rating}}) si existe (fuente única de reseñas);
    si no, REVIEWS_FALLBACK (abajo: el ÚNICO sitio que hay que cambiar). Si HCReviews llega más tarde (o el evento
    hc:reviews:ready), se repinta solo ese bloque.
  - Avisos de maqueta (A.6) con window.HC.maqueta y los textos de window.HC.avisos (snippets/hc-config.liquid).
  - Importes: siempre con window.HC.moneyFormat (formato de la tienda, sin «EUR»).
  Una sola instancia por página (window.HCCart.booted), aunque el archivo se cargue dos veces.
*/
(function (factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module && module.exports) {
    module.exports = api; // pruebas en Node
  }
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (window.HCCart && window.HCCart.booted) return;
    window.HCCart = api;
    api.boot(window, document);
  }
})(function () {
  'use strict';

  /* ===== Valoración y reseña de respaldo (solo si la página no tiene window.HCReviews). Único sitio que cambiar. ===== */
  var REVIEWS_FALLBACK = {
    rating: 4.8,
    total: 953,
    sample: {
      author: 'Teresa G.',
      rating: 5,
      body: 'La llevo yo, y mi hija vive a 200 km. Tiene la app en su móvil y, cuando probamos el botón, le llegó el aviso al momento.',
    },
  };

  var KEY_END = 'hc-cart-reserva-fin';
  var DEFAULT_MINUTES = 10;
  var DEFAULT_FORMAT = '{{amount_with_comma_separator}} €';
  var REVIEW_MAX = 160;

  /* Aviso de mejora (A.5.6): la cola del texto según las unidades que hay ahora. El importe se calcula. */
  var UPGRADE_TAIL = {
    1: ' y desbloquea el 2.º regalo y el envío gratis',
    2: ' y desbloquea el 3.er regalo y el mejor precio por unidad',
  };

  var IDS = {
    drawer: { row: 'CartDrawer-Item-', input: 'Drawer-quantity-', error: 'CartDrawer-LineItemError-', remove: 'CartDrawer-Remove-', checkout: 'CartDrawer-Checkout' },
    page: { row: 'CartItem-', input: 'Quantity-', error: 'Line-item-error-', remove: 'Remove-', checkout: 'checkout' },
  };

  var ICON = {
    minus: '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true" focusable="false"><path d="M4 10h12" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    plus: '<svg viewBox="0 0 20 20" width="14" height="14" aria-hidden="true" focusable="false"><path d="M4 10h12M10 4v12" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    trash: '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" focusable="false"><path d="M4 7h16M9.5 7V4.8h5V7M6.5 7l.9 12.2c.1.9.8 1.6 1.7 1.6h5.8c.9 0 1.6-.7 1.7-1.6L17.5 7M10 11v6M14 11v6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  };

  /* ---------- Utilidades puras ---------- */
  function str(value) {
    return value === null || value === undefined ? '' : String(value).trim();
  }

  function esc(value) {
    return (value === null || value === undefined ? "" : String(value)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function toInt(value, fallback) {
    var n = Math.round(Number(value));
    return isFinite(n) ? n : fallback === undefined ? 0 : fallback;
  }

  function toNum(value) {
    if (value === null || value === undefined || value === '') return null;
    var n = Number(value);
    return isFinite(n) ? n : null;
  }

  /* Solo URL propias o de Shopify: //dominio/…, https://… o /ruta. */
  function safeUrl(url) {
    var u = str(url);
    return /^(https:)?\/\/[^\s"'<>]+$/.test(u) || /^\/(?!\/)[^\s"'<>]*$/.test(u) ? u : '';
  }

  function sizedImage(url, width) {
    var u = safeUrl(url);
    if (!u) return '';
    if (/[?&]width=\d+/.test(u)) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* Recorta por frases enteras si caben (al menos la mitad del máximo); si no, por palabras con «…». */
  function shorten(text, max) {
    var t = str(text).replace(/\s+/g, ' ');
    var chars = Array.from(t);
    if (chars.length <= max) return t;
    var parts = t.match(/[^.!?…]+[.!?…]+(?=\s|$)/g) || [];
    var whole = '';
    for (var p = 0; p < parts.length; p++) {
      var next = (whole + parts[p]).trim();
      if (Array.from(next).length > max) break;
      whole = next;
    }
    if (Array.from(whole).length >= max * 0.5) return whole;
    var cut = chars.slice(0, max).join('');
    var space = cut.lastIndexOf(' ');
    if (space > max * 0.6) cut = cut.slice(0, space);
    return cut.replace(/[\s.,;:¡!¿?\-–—]+$/, '') + '…';
  }

  /* ---------- Dinero (formato de la tienda: window.HC.moneyFormat) ---------- */
  function formatAmount(cents, precision, thousands, decimal) {
    var n = Math.round(Number(cents) || 0);
    var negative = n < 0;
    var parts = (Math.abs(n) / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return (negative ? '-' : '') + whole + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents, format) {
    var fmt = (str(format) || DEFAULT_FORMAT)
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&euro;/g, '€')
      .replace(/&amp;/g, '&');
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount':
          return formatAmount(cents, 2, ',', '.');
        case 'amount_no_decimals':
          return formatAmount(cents, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator':
          return formatAmount(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return formatAmount(cents, 2, "'", '.');
        case 'amount_with_space_separator':
          return formatAmount(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return formatAmount(cents, 0, ' ', ',');
        case 'amount_with_period_and_space_separator':
          return formatAmount(cents, 2, ' ', '.');
        default: // amount_with_comma_separator y cualquier otro: «1.234,56»
          return formatAmount(cents, 2, '.', ',');
      }
    });
    return out === fmt ? formatAmount(cents, 2, '.', ',') : out;
  }

  /* ---------- Configuración (window.HC, snippets/hc-config.liquid) ---------- */
  function config(hc) {
    if (hc && hc.__hcNorm) return hc;
    var h = hc && typeof hc === 'object' ? hc : {};
    var avisos = {
      img: '',
      ejemplo: 'POCAS UNIDADES❗',
      valoracion: '',
      resena: '',
    };
    if (h.avisos && typeof h.avisos === 'object') {
      Object.keys(avisos).forEach(function (k) {
        if (str(h.avisos[k])) avisos[k] = str(h.avisos[k]);
      });
    }
    var regalos = (Array.isArray(h.regalos) ? h.regalos : [])
      .map(function (g, i) {
        return {
          n: toInt(g && g.n, i + 1),
          nombre: str(g && g.nombre),
          valor: Math.max(0, toInt(g && g.valor)),
          min: Math.max(1, toInt(g && g.min, 1)),
          img: safeUrl(g && g.img) || null,
        };
      })
      .filter(function (g) {
        return g.nombre;
      });
    return {
      __hcNorm: true,
      maqueta: !!h.maqueta,
      avisos: avisos,
      moneyFormat: str(h.moneyFormat) || DEFAULT_FORMAT,
      desc2: Math.max(0, toInt(h.desc2)),
      desc3: Math.max(0, toInt(h.desc3)),
      envio: Math.max(0, toInt(h.envio)),
      envioGratis: Math.max(0, toInt(h.envioGratis)),
      garantiaDias: Math.max(0, toInt(h.garantiaDias, 90)) || 90,
      productUrl: safeUrl(h.productUrl) || '/',
      regalos: regalos,
    };
  }

  /* ---------- Oferta ---------- */
  function descFor(units, cfg) {
    if (units >= 3) return cfg.desc3;
    if (units === 2) return cfg.desc2;
    return 0;
  }

  function packLabel(qty) {
    if (qty === 2) return 'Pack 2 · Más popular';
    if (qty === 3) return 'Pack 3 · Mejor precio';
    if (qty >= 4) return 'Pack ' + qty;
    return '1 pulsera';
  }

  /* «Pulsera SOS HeyCuida · Botón de emergencia…» → «Pulsera SOS HeyCuida»; sin « · », el título tal cual. */
  function shortTitle(title) {
    var t = str(title);
    var i = t.indexOf(' · ');
    return i > 0 ? t.slice(0, i).trim() : t;
  }

  function unitsWord(n) {
    return n === 1 ? '1 pulsera' : n + ' pulseras';
  }

  function lockText(min) {
    return 'Bloqueado · con ' + unitsWord(min);
  }

  /*
    Modelo del carrito a partir del objeto de la Ajax Cart API (/cart.js o {{ cart | json }}).
    compareAt: { variant_id: compare_at en céntimos }. cfg: window.HC (o ya normalizado).
    - Precio de línea = final_line_price menos su parte de los descuentos de pedido (si el descuento automático es de
      pedido y no de producto), para que la suma de líneas sea siempre total_price y cuadre con el ahorro.
    - Tachado de línea = max(compare_at, precio) × uds. Ahorro = Σ tachados − total_price.
    - Envío gratis si total_price ≥ envioGratis (total tras descuentos). Total = total_price + envío si aplica.
  */
  function computeCart(cart, compareAt, cfgIn) {
    var cfg = config(cfgIn);
    var c = cart && typeof cart === 'object' ? cart : {};
    var items = (Array.isArray(c.items) ? c.items : []).filter(function (it) {
      return it && toInt(it.quantity) > 0;
    });
    var cmp = compareAt && typeof compareAt === 'object' ? compareAt : {};

    var units = 0;
    var linesSum = 0;
    items.forEach(function (it) {
      units += toInt(it.quantity);
      linesSum += toInt(it.final_line_price !== undefined ? it.final_line_price : it.line_price);
    });
    var total = c.total_price !== undefined ? Math.max(0, toInt(c.total_price)) : linesSum;
    var itemsSubtotal = c.items_subtotal_price !== undefined ? toInt(c.items_subtotal_price) : linesSum;
    var orderLevel = Math.max(0, itemsSubtotal - total);

    var allocated = 0;
    var compareSum = 0;
    var lines = items.map(function (it, i) {
      var qty = toInt(it.quantity);
      var finalLine = toInt(it.final_line_price !== undefined ? it.final_line_price : it.line_price);
      var share = 0;
      if (orderLevel > 0 && linesSum > 0) {
        share = i === items.length - 1 ? orderLevel - allocated : Math.round((orderLevel * finalLine) / linesSum);
        allocated += share;
      }
      var unit = toInt(it.original_price !== undefined ? it.original_price : it.price);
      var cmpUnit = toInt(cmp[String(it.variant_id)] !== undefined ? cmp[String(it.variant_id)] : cmp[String(it.id)]);
      var compareLine = Math.max(cmpUnit, unit) * qty;
      var net = Math.max(0, finalLine - share);
      compareSum += compareLine;
      var rule = it.quantity_rule || {};
      var image = (it.featured_image && it.featured_image.url) || it.image || '';
      return {
        index: i + 1,
        key: str(it.key),
        variantId: str(it.variant_id || it.id),
        title: shortTitle(it.product_title || it.title),
        url: safeUrl(it.url) || cfg.productUrl,
        image: safeUrl(image),
        qty: qty,
        min: Math.max(0, toInt(rule.min, 1)),
        max: rule.max === null || rule.max === undefined ? null : toInt(rule.max),
        step: Math.max(1, toInt(rule.increment, 1)),
        chip: packLabel(qty),
        unitPrice: unit,
        net: net,
        compareLine: compareLine,
        showCompare: compareLine > net,
      };
    });

    var count = c.item_count !== undefined ? Math.max(0, toInt(c.item_count)) : units;
    var empty = lines.length === 0;
    var hasGoal = cfg.envioGratis > 0;
    var free = hasGoal ? total >= cfg.envioGratis : cfg.envio === 0;
    var shipping = empty || free ? 0 : cfg.envio;

    var gifts = cfg.regalos.map(function (g) {
      return { n: g.n, nombre: g.nombre, valor: g.valor, min: g.min, img: g.img, unlocked: units >= g.min, lock: lockText(g.min) };
    });

    var upgrade = null;
    if (!empty && UPGRADE_TAIL[units]) {
      var price = lines[0].unitPrice;
      var amount = price * (units + 1) - descFor(units + 1, cfg) - (price * units - descFor(units, cfg));
      if (amount > 0) upgrade = { units: units, line: lines[0].index, nextQty: lines[0].qty + 1, variantId: lines[0].variantId, amount: amount };
    }

    return {
      empty: empty,
      count: count,
      units: units,
      lines: lines,
      total: total,
      subtotal: total,
      shipping: shipping,
      free: free,
      grandTotal: total + shipping,
      savings: Math.max(0, compareSum - total),
      bar: {
        enabled: hasGoal && !empty,
        reached: hasGoal && free,
        remaining: hasGoal ? Math.max(0, cfg.envioGratis - total) : 0,
        pct: hasGoal ? Math.min(100, Math.round((total * 1000) / cfg.envioGratis) / 10) : 0,
      },
      gifts: gifts,
      upgrade: upgrade,
    };
  }

  /* Todos los textos visibles que salen de cálculos (los que pinta renderView y comprueban las pruebas). */
  function texts(model, cfgIn) {
    var cfg = config(cfgIn);
    function m(cents) {
      return formatMoney(cents, cfg.moneyFormat);
    }
    var upgrade = '';
    var upgradeAmount = '';
    if (model.upgrade) {
      upgradeAmount = m(model.upgrade.amount);
      upgrade = 'Añade 1 más por solo ' + upgradeAmount + UPGRADE_TAIL[model.upgrade.units];
    }
    return {
      title: 'Tu carrito (' + model.count + ')',
      bar: !model.bar.enabled ? '' : model.bar.reached ? '🎉 ¡Tienes ENVÍO GRATIS!' : 'Te faltan ' + m(model.bar.remaining) + ' para el ENVÍO GRATIS 🚚',
      lines: model.lines.map(function (l) {
        return { title: l.title, chip: l.chip, price: m(l.net), compare: l.showCompare ? m(l.compareLine) : '' };
      }),
      gifts: model.gifts.map(function (g) {
        return { nombre: g.nombre, estado: g.unlocked ? 'GRATIS' : g.lock, valor: m(g.valor) };
      }),
      upgrade: upgrade,
      upgradeAmount: upgradeAmount,
      savings: model.savings > 0 ? '💰 Ahorras ' + m(model.savings) : '',
      subtotal: m(model.subtotal),
      shipping: model.shipping === 0 ? 'GRATIS' : m(model.shipping),
      total: m(model.grandTotal),
      checkout: '🔒 Finalizar compra · ' + m(model.grandTotal),
      trust: '🔒 Pago seguro · 🚚 Envío asegurado · 🛡️ Garantía de ' + cfg.garantiaDias + ' días',
    };
  }

  /* ---------- Reseñas ---------- */
  function clampRating(value) {
    var v = Number(value);
    return isFinite(v) ? Math.max(0, Math.min(5, v)) : 0;
  }

  function formatRating(value) {
    return (Math.round(clampRating(value) * 10) / 10).toFixed(1).replace('.', ',');
  }

  function opinionsText(total) {
    var n = Math.max(0, toInt(total));
    return n === 1 ? '1 opinión' : String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' opiniones';
  }

  /* window.HCReviews → {source, rating, total, sample}; sin datos válidos, REVIEWS_FALLBACK. */
  function reviewsData(src) {
    var fb = REVIEWS_FALLBACK;
    var s = src && typeof src === 'object' ? src : null;
    var rating = s ? clampRating(s.rating) : 0;
    var total = s ? toInt(s.total) : 0;
    if (!s || !(rating > 0) || !(total > 0)) {
      return { source: 'fallback', rating: fb.rating, total: fb.total, sample: fb.sample };
    }
    var sample = s.sample && typeof s.sample === 'object' && str(s.sample.body) ? s.sample : fb.sample;
    return { source: 'hc', rating: rating, total: total, sample: sample };
  }

  function reviewsText(rv) {
    return formatRating(rv.rating) + ' ★ · ' + opinionsText(rv.total);
  }

  /* ---------- Marcado ---------- */
  function aviso(cfg, tipo, extra) {
    if (!cfg.maqueta || !cfg.avisos[tipo]) return '';
    return '<span class="hc-aviso hc-aviso--' + tipo + (extra ? ' ' + extra : '') + '">' + esc(cfg.avisos[tipo]) + '</span>';
  }

  function starRow(rating) {
    var full = Math.round(clampRating(rating));
    var out = '';
    for (var i = 0; i < 5; i++) out += '<span class="' + (i < full ? 'is-on' : 'is-off') + '">★</span>';
    return '<span class="hc-rev__stars" role="img" aria-label="' + full + ' de 5 estrellas">' + out + '</span>';
  }

  /* Foto de perfil de la reseña (window.HCReviews.sample.avatar); sin foto, círculo con la inicial. */
  function avatarTag(sample) {
    var src = safeUrl(sample.avatar);
    var name = str(sample.author);
    if (src) {
      var src2 = safeUrl(sample.avatar2x);
      return '<img class="hc-rev__avatar" src="' + esc(sizedImage(src, 96)) + '"' + (src2 ? ' srcset="' + esc(sizedImage(src, 96)) + ' 1x, ' + esc(src2) + ' 2x"' : '') +
        ' width="40" height="40" alt="' + esc('Foto de perfil de ' + name) + '" loading="lazy" decoding="async">';
    }
    var ini = (Array.from(name.replace(/^[^A-Za-zÀ-ÿ]+/, ''))[0] || '').toUpperCase();
    return ini ? '<span class="hc-rev__avatar hc-rev__avatar--ini" aria-hidden="true">' + esc(ini) + '</span>' : '';
  }

  function renderReviews(rv, cfg) {
    var sample = rv.sample || {};
    var hasPhoto = !!safeUrl(sample.avatar);
    var avisos = aviso(cfg, 'resena', 'hc-aviso--inline') + (hasPhoto ? aviso(cfg, 'img', 'hc-aviso--inline') : '');
    var quote = str(sample.body)
      ? '<figure class="hc-rev__quote">' +
        '<figcaption class="hc-rev__head">' + avatarTag(sample) +
        '<span class="hc-rev__who"><span class="hc-rev__name">' + esc(str(sample.author)) + '</span>' + starRow(sample.rating || 5) + '</span>' +
        (avisos ? '<span class="hc-rev__avisos">' + avisos + '</span>' : '') +
        '</figcaption>' +
        '<blockquote><p>«' + esc(shorten(sample.body, REVIEW_MAX)) + '»</p></blockquote>' +
        '</figure>'
      : '';
    return (
      '<p class="hc-rev__avg"><span class="hc-rev__num">' + esc(formatRating(rv.rating)) + ' <span class="hc-rev__star">★</span></span>' +
      '<span>· ' + esc(opinionsText(rv.total)) + '</span>' + aviso(cfg, 'valoracion') + '</p>' +
      quote
    );
  }

  function renderEmpty(cfg) {
    return (
      '<div class="hc-cart-empty drawer__inner-empty">' +
      '<span class="hc-cart-empty__icon" aria-hidden="true">🛒</span>' +
      '<p class="hc-cart-empty__title">Tu carrito está vacío</p>' +
      '<a class="hc-cart__checkout hc-cart-empty__btn" href="' + esc(cfg.productUrl) + '">Ver la pulsera</a>' +
      '</div>'
    );
  }

  function renderLine(l, t, cfg, ids) {
    var n = l.index;
    var img = l.image
      ? '<img src="' + esc(sizedImage(l.image, 180)) + '" width="72" height="72" alt="" loading="eager" decoding="async">'
      : '';
    var qty =
      '<quantity-input class="hc-qty">' +
      '<button class="quantity__button hc-qty__btn" name="minus" type="button"><span class="visually-hidden">Quitar una</span>' + ICON.minus + '</button>' +
      '<input class="hc-qty__input" type="number" inputmode="numeric" id="' + ids.input + n + '" name="updates[]" value="' + l.qty + '"' +
      ' min="' + l.min + '"' + (l.max !== null ? ' max="' + l.max + '"' : '') + ' step="' + l.step + '"' +
      ' data-index="' + n + '" data-quantity-variant-id="' + esc(l.variantId) + '" data-cart-quantity="' + l.qty + '"' +
      ' aria-label="Cantidad de ' + esc(l.title) + '">' +
      '<button class="quantity__button hc-qty__btn" name="plus" type="button"><span class="visually-hidden">Añadir una</span>' + ICON.plus + '</button>' +
      '</quantity-input>';
    var remove =
      '<cart-remove-button id="' + ids.remove + n + '" data-index="' + n + '">' +
      '<button type="button" class="hc-line__remove" aria-label="Quitar ' + esc(l.title) + ' del carrito" data-variant-id="' + esc(l.variantId) + '">' + ICON.trash + '</button>' +
      '</cart-remove-button>';
    var price =
      '<div class="hc-line__price">' +
      (t.compare ? '<s><span class="visually-hidden">Antes: </span>' + esc(t.compare) + '</s>' : '') +
      '<strong><span class="visually-hidden">Ahora: </span>' + esc(t.price) + '</strong>' +
      '</div>';
    return (
      '<li id="' + ids.row + n + '" class="cart-item hc-line">' +
      '<a class="hc-line__media" href="' + esc(l.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="hc-line__body">' +
      '<a class="hc-line__title cart-item__name" href="' + esc(l.url) + '">' + esc(t.title) + '</a>' +
      '<div class="hc-line__tags"><span class="hc-line__chip">' + esc(t.chip) + '</span>' + (img ? aviso(cfg, 'img', 'hc-aviso--inline') : '') + '</div>' +
      '<div class="hc-line__row">' + qty + remove + price + '</div>' +
      '<div id="' + ids.error + n + '" class="hc-line__error" role="alert"><small class="cart-item__error-text"></small></div>' +
      '</div>' +
      '</li>'
    );
  }

  /* Regalo en la cuadrícula 2×2: miniatura, nombre y debajo «GRATIS» + valor tachado (o «🔒 Pack N» + valor tachado).
     El aviso de imagen ilustrativa va una sola vez, en la cabecera de «Tus regalos». */
  function renderGift(g, t) {
    var media = g.img
      ? '<img src="' + esc(sizedImage(g.img, 120)) + '" width="36" height="36" alt="" loading="eager" decoding="async">'
      : '<span aria-hidden="true">🎁</span>';
    var meta = g.unlocked
      ? '<span class="hc-gift__free">GRATIS</span>'
      : '<span class="hc-gift__status"><span aria-hidden="true">🔒 Pack ' + g.min + '</span><span class="visually-hidden">' + esc(t.estado) + '</span></span>';
    return (
      '<li class="hc-gift ' + (g.unlocked ? 'is-unlocked' : 'is-locked') + '">' +
      '<span class="hc-gift__media">' + media + '</span>' +
      '<span class="hc-gift__text">' +
      '<span class="hc-gift__name">' + esc(t.nombre) + '</span>' +
      '<span class="hc-gift__meta">' + meta + '<s class="hc-gift__value"><span class="visually-hidden">Valor: </span>' + esc(t.valor) + '</s></span>' +
      '</span>' +
      '</li>'
    );
  }

  /* Vista completa de un carrito. opts: { ctx: 'drawer'|'page', cfg, payHtml, reviews } */
  function renderView(model, opts) {
    var o = opts || {};
    var cfg = config(o.cfg);
    if (model.empty) return renderEmpty(cfg);
    var ctx = o.ctx === 'page' ? 'page' : 'drawer';
    var ids = IDS[ctx];
    var t = texts(model, cfg);
    var html = '';

    if (t.bar) {
      html +=
        '<div class="hc-cart__card hc-ship' + (model.bar.reached ? ' is-reached' : '') + '">' +
        '<p class="hc-ship__text" role="status">' + esc(t.bar) + '</p>' +
        '<div class="hc-ship__track" aria-hidden="true"><div class="hc-ship__fill" style="width: ' + model.bar.pct + '%;"></div></div>' +
        '</div>';
    }

    html +=
      '<ul class="hc-cart__lines" role="list">' +
      model.lines.map(function (l, i) {
        return renderLine(l, t.lines[i], cfg, ids);
      }).join('') +
      '</ul>';

    if (model.gifts.length) {
      html +=
        '<section class="hc-cart__card hc-gifts" aria-label="Tus regalos">' +
        '<div class="hc-gifts__head"><h3 class="hc-gifts__title">🎁 TUS REGALOS</h3>' +
        (model.gifts.some(function (g) { return g.img; }) ? aviso(cfg, 'img', 'hc-aviso--inline') : '') + '</div>' +
        '<ul class="hc-gifts__list" role="list">' +
        model.gifts.map(function (g, i) {
          return renderGift(g, t.gifts[i]);
        }).join('') +
        '</ul></section>';
    }

    if (model.upgrade) {
      var tail = t.upgrade.slice(('Añade 1 más por solo ' + t.upgradeAmount).length);
      html +=
        '<div class="hc-upsell">' +
        '<p class="hc-upsell__text">Añade 1 más por solo <strong>' + esc(t.upgradeAmount) + '</strong>' + esc(tail) + '</p>' +
        '<button type="button" class="hc-upsell__btn" data-hc-cart-add data-line="' + model.upgrade.line + '" data-qty="' + model.upgrade.nextQty + '"' +
        ' data-variant-id="' + esc(model.upgrade.variantId) + '" aria-label="Añadir 1 pulsera más">Añadir</button>' +
        '</div>';
    }

    html +=
      '<section class="hc-cart__card hc-sum" aria-label="Resumen del pedido">' +
      (t.savings ? '<p class="hc-sum__save">' + esc(t.savings) + '</p>' : '') +
      '<dl class="hc-sum__rows">' +
      '<div class="hc-sum__row"><dt>Subtotal</dt><dd>' + esc(t.subtotal) + '</dd></div>' +
      '<div class="hc-sum__row"><dt>Envío</dt><dd' + (model.shipping === 0 ? ' class="is-free"' : '') + '>' + esc(t.shipping) + '</dd></div>' +
      '<div class="hc-sum__row hc-sum__row--total"><dt>Total</dt><dd>' + esc(t.total) + '</dd></div>' +
      '</dl>' +
      '<p class="hc-sum__stock">⚠️ Pocas unidades: el stock no se reserva hasta que finalices la compra</p>' +
      '</section>';

    html +=
      '<div class="hc-cart__cta">' +
      '<button type="submit" name="checkout" id="' + ids.checkout + '" class="hc-cart__checkout">' + esc(t.checkout) + '</button>' +
      '<a class="hc-cart__continue" href="' + esc(cfg.productUrl) + '" data-hc-cart-continue>Seguir comprando</a>' +
      '</div>';

    html +=
      '<div class="hc-cart__trust">' +
      (str(o.payHtml) ? '<ul class="hc-cart__pay" role="list" aria-label="Métodos de pago">' + o.payHtml + '</ul>' : '') +
      '<p class="hc-cart__badges">' + esc(t.trust) + '</p>' +
      '<div class="hc-cart__card hc-rev" data-hc-cart-reviews>' + renderReviews(o.reviews || reviewsData(null), cfg) + '</div>' +
      '</div>';

    return html;
  }

  /* ---------- Reloj de la reserva (puro) ---------- */
  function clampMinutes(value) {
    var n = parseInt(value, 10);
    if (!isFinite(n)) n = DEFAULT_MINUTES;
    return Math.max(1, Math.min(60, n));
  }

  /* «mm:ss» con los segundos hacia arriba: 600 000 ms → 10:00; 599 000 ms → 09:59. */
  function formatClock(ms) {
    var total = Math.max(0, Math.ceil((Number(ms) || 0) / 1000));
    var m = Math.floor(total / 60);
    var s = total % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  /*
    Hora de fin de la reserva. end: la guardada (texto/número o null). count: artículos del carrito.
    - Con artículos y sin hora, o con la hora ya pasada: empieza otra vez (ahora + duración).
    - Una hora más lejos que la duración (reloj cambiado, valor raro) se recorta.
    - Con el carrito vacío no se toca: si se vuelve a llenar a tiempo, sigue la misma cuenta.
  */
  function nextReservation(end, count, now, durationMs) {
    var e = toNum(end);
    if (e !== null && e <= 0) e = null;
    if (e !== null && e - now > durationMs) e = now + durationMs;
    var restarted = false;
    if (count > 0 && (e === null || e <= now)) {
      e = now + durationMs;
      restarted = true;
    }
    return { end: e, restarted: restarted };
  }

  /* ---------- Almacén (localStorage con respaldo en memoria) ---------- */
  function makeStore(win) {
    var mem = {};
    var ls = null;
    try {
      ls = win.localStorage;
      ls.setItem('hc-cart-prueba', '1');
      ls.removeItem('hc-cart-prueba');
    } catch (e) {
      ls = null;
    }
    return {
      get: function (key) {
        if (ls) {
          try {
            var v = ls.getItem(key);
            if (v !== null) return v;
          } catch (e) {
            /* sin almacén: memoria */
          }
        }
        return Object.prototype.hasOwnProperty.call(mem, key) ? mem[key] : null;
      },
      set: function (key, value) {
        mem[key] = String(value);
        if (!ls) return;
        try {
          ls.setItem(key, String(value));
        } catch (e) {
          /* cuota llena o bloqueo: queda en memoria */
        }
      },
    };
  }

  /* ---------- Navegador ---------- */
  function boot(win, doc) {
    var api = module_api;
    api.booted = true;
    var store = makeStore(win);
    var state = { count: null, busy: false, observer: null };
    api.state = state;

    function cfg() {
      return config(win.HC);
    }

    function readInitialCount() {
      var el = doc.querySelector('[data-hc-cart][data-hc-count]');
      var n = el ? parseInt(el.getAttribute('data-hc-count'), 10) : 0;
      return isFinite(n) && n > 0 ? n : 0;
    }

    function syncChrome(root, model) {
      state.count = model.count;
      Array.prototype.forEach.call(doc.querySelectorAll('[data-hc-cart-count]'), function (el) {
        if (el.textContent !== String(model.count)) el.textContent = String(model.count);
      });
      var drawer = root.closest ? root.closest('cart-drawer') : null;
      if (drawer) {
        drawer.classList.toggle('is-empty', model.empty);
        var items = drawer.querySelector('cart-drawer-items');
        if (items) items.classList.toggle('is-empty', model.empty);
      }
    }

    function renderRoot(root) {
      root.setAttribute('data-hc-rendered', '1');
      var dataEl = root.querySelector('script[data-hc-cart-data]');
      var view = root.querySelector('[data-hc-cart-view]');
      if (!dataEl || !view) return;
      var data;
      try {
        data = JSON.parse(dataEl.textContent || '{}');
      } catch (e) {
        return; // se queda el respaldo del Liquid
      }
      var c = cfg();
      var model = computeCart(data.cart, data.compareAt, c);
      var pay = root.querySelector('template[data-hc-cart-pay]');
      var reviews = reviewsData(win.HCReviews);
      view.innerHTML = renderView(model, {
        ctx: root.getAttribute('data-hc-cart'),
        cfg: c,
        payHtml: pay ? pay.innerHTML : '',
        reviews: reviews,
      });
      root.setAttribute('data-hc-reviews', reviews.source);
      syncChrome(root, model);
    }

    function tickTimers() {
      var nodes = doc.querySelectorAll('[data-hc-cart-timer]');
      if (!nodes.length) return;
      var count = state.count === null ? readInitialCount() : state.count;
      var dur = clampMinutes(nodes[0].getAttribute('data-minutes')) * 60000;
      var now = Date.now();
      var next = nextReservation(store.get(KEY_END), count, now, dur);
      if (next.end !== null && String(next.end) !== store.get(KEY_END)) store.set(KEY_END, next.end);
      var text = formatClock(next.end === null ? dur : next.end - now);
      Array.prototype.forEach.call(nodes, function (node) {
        var time = node.querySelector('[data-hc-cart-timer-time]');
        if (time && time.textContent !== text) time.textContent = text;
        var hide = !(count > 0);
        if (node.hidden !== hide) node.hidden = hide;
      });
    }

    /* Si las reseñas llegan después del pintado, se cambia solo el bloque de reseñas. */
    function upgradeReviews() {
      if (!win.HCReviews) return;
      var reviews = reviewsData(win.HCReviews);
      if (reviews.source !== 'hc') return;
      Array.prototype.forEach.call(doc.querySelectorAll('[data-hc-cart][data-hc-reviews="fallback"]'), function (root) {
        var host = root.querySelector('[data-hc-cart-reviews]');
        if (host) host.innerHTML = renderReviews(reviews, cfg());
        root.setAttribute('data-hc-reviews', 'hc');
      });
    }

    function refresh() {
      if (state.busy) return;
      state.busy = true;
      try {
        Array.prototype.forEach.call(doc.querySelectorAll('[data-hc-cart]:not([data-hc-rendered])'), renderRoot);
        upgradeReviews();
        tickTimers();
      } catch (e) {
        if (win.console) win.console.error('HeyCuida carrito:', e);
      } finally {
        state.busy = false;
      }
    }

    function observe() {
      if (!win.MutationObserver || !doc.body || state.observer) return;
      state.observer = new win.MutationObserver(function () {
        if (doc.querySelector('[data-hc-cart]:not([data-hc-rendered])')) refresh();
      });
      state.observer.observe(doc.body, { childList: true, subtree: true });
    }

    /* «Añadir» del aviso de mejora: sube la línea en 1 con el JS del tema (mismo camino que el botón +). */
    function addOne(btn) {
      if (btn.disabled) return;
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var qty = parseInt(btn.getAttribute('data-qty'), 10);
      if (!(line > 0) || !(qty > 0)) return;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      var host = btn.closest('cart-drawer-items, cart-items');
      if (host && typeof host.updateQuantity === 'function') {
        host.updateQuantity(String(line), qty, 'plus', btn.getAttribute('data-variant-id'));
        return;
      }
      // Sin el JS del tema: Ajax Cart API y recarga.
      win
        .fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty }),
        })
        .then(function () {
          win.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        });
    }

    doc.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      var add = target.closest('[data-hc-cart-add]');
      if (add) {
        event.preventDefault();
        addOne(add);
        return;
      }
      var cont = target.closest('[data-hc-cart-continue]');
      if (cont) {
        var drawer = cont.closest('cart-drawer');
        if (drawer && typeof drawer.close === 'function') {
          event.preventDefault();
          drawer.close();
        }
      }
    });

    /* Cambios hechos desde el cajón estando en /cart: la página se pone al día (el tema no lo hace). */
    function syncPageFromDrawer(event) {
      var pageItems = doc.getElementById('main-cart-items');
      if (!pageItems || !event || !event.cartData) return;
      var sections = event.cartData.sections || {};
      var hasPage = Object.keys(sections).some(function (k) {
        return k === pageItems.getAttribute('data-id');
      });
      if (hasPage) return;
      var url = ((win.routes && win.routes.cart_url) || '/cart') + '?section_id=' + encodeURIComponent(pageItems.getAttribute('data-id') || 'main-cart-items');
      win
        .fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var fresh = new win.DOMParser().parseFromString(html, 'text/html').querySelector('#main-cart-items .js-contents');
          var target = pageItems.querySelector('.js-contents');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }
    try {
      /* global subscribe, PUB_SUB_EVENTS */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, syncPageFromDrawer);
      }
    } catch (e) {
      /* sin pubsub del tema */
    }

    doc.addEventListener('hc:reviews-ready', refresh); // lo lanza assets/lm-reviews.js
    doc.addEventListener('hc:reviews:ready', refresh);
    doc.addEventListener('shopify:section:load', refresh);
    doc.addEventListener('visibilitychange', function () {
      if (!doc.hidden) refresh();
    });
    win.addEventListener('pageshow', refresh);
    win.addEventListener('storage', function (event) {
      if (event && event.key === KEY_END) tickTimers();
    });

    function start() {
      observe();
      refresh();
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
    else start();

    /* El único intervalo: el reloj (y las reseñas que lleguen tarde). */
    state.interval = win.setInterval(function () {
      if (!doc.hidden) refresh();
    }, 1000);
  }

  var module_api = {
    version: 2,
    booted: false,
    keys: { end: KEY_END },
    REVIEWS_FALLBACK: REVIEWS_FALLBACK,
    // lógica pura (pruebas en Node)
    config: config,
    formatMoney: formatMoney,
    descFor: descFor,
    packLabel: packLabel,
    shortTitle: shortTitle,
    lockText: lockText,
    computeCart: computeCart,
    texts: texts,
    reviewsData: reviewsData,
    reviewsText: reviewsText,
    formatRating: formatRating,
    renderReviews: renderReviews,
    renderView: renderView,
    clampMinutes: clampMinutes,
    formatClock: formatClock,
    nextReservation: nextReservation,
    makeStore: makeStore,
    esc: esc,
    safeUrl: safeUrl,
    // arranque en el navegador
    boot: boot,
  };
  return module_api;
});
